// https://feathericons.com/
import { icons } from "feather-icons";

const iconMap = {
  hexagon: icons["hexagon"],
  triangle: icons["triangle"],
  circle: icons["circle"],
  folder: icons["folder"],
  dollarSign: icons["dollar-sign"],
  refreshCounterClockwise: icons["refresh-ccw"],
  navigation: icons["navigation"],
};

export default iconMap;
